function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "VisitorsSmall_svg__17_a",
  x1: "0%",
  x2: "100%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#80DFFD"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#3ABEFA"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "url(#VisitorsSmall_svg__17_a)",
  rx: 4
}), React.createElement("path", {
  fill: "#D0F9FE",
  d: "M18 5a2 2 0 012 2v10a2 2 0 01-2 2H6a2 2 0 01-2-2V7a2 2 0 012-2h12zm0 3H6a1 1 0 00-.993.883L5 9v8a1 1 0 00.883.993L6 18h12a1 1 0 00.993-.883L19 17V9a1 1 0 00-1-1zm-6 5a1 1 0 011 1v2a1 1 0 01-1 1H7a1 1 0 01-1-1v-2a1 1 0 011-1h5zm5 0a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2a1 1 0 011-1h2zm0-4a1 1 0 011 1v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-1a1 1 0 011-1h10zM6.25 5.75a.75.75 0 100 1.5.75.75 0 000-1.5zm2.25 0a.75.75 0 100 1.5.75.75 0 000-1.5zm2.25 0a.75.75 0 100 1.5.75.75 0 000-1.5z"
}));

var SvgVisitorsSmall = function SvgVisitorsSmall(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
};

export default SvgVisitorsSmall;